import"./constants.js";var t=function(t,n){return n?"".concat(t,"_").concat(n):t};export{t as getTestId};
